module.exports = __webpack_public_path__ + "img/18.5e38fe03.jpg";